<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="h600_dialog abow_dialog"
    width="1000px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div>
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
        style="padding-bottom:5px;padding-top:5px"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              签到人：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-select
              v-model="masterList.search.manageUserId"
              filterable
              clearable
              placeholder="请选择签到人"
              style="width:100%"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div
        ref="container"
        style="width:990px;height:510px"
      />
    </div>
  </el-dialog>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { loadUserSelectDataByUserTypeApi } from '@/api/user'
import { findCheckInStoreByTMapApi } from '@/api/storeVisitCheckIn'
import { getLocationByAddressApi } from '@/api/store'
export default {
  name: 'CheckInStore',
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 主列表
      masterList: {
        // 查询条件
        search: {
          manageUserId: null,
          billType: 1
        }
      },
      userOptions: [],
      map: null, // 地图底层
      markers: null, //标记数组
      markerCluster: null //标记集
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.userOptions = []
        this.masterList.search.manageUserId = null
        this.initUserSelectData()
      }
    }
  },
  methods: {
    searchData() {
      if (this.masterList.search.manageUserId === null || this.masterList.search.manageUserId === undefined || this.masterList.search.manageUserId === '') {
        this.$message({
          message: '请选择签到人',
          type: 'warning'
        })
        return false
      }
      // this.masterList.search.searchDate = '2020-08-26'
      findCheckInStoreByTMapApi(this.masterList.search).then(res => {
        this.storeList = res.data
        if (this.storeList !== null && this.storeList !== undefined && this.storeList.length > 0) {
          let address = this.storeList[0].provinceName + this.storeList[0].cityName
          getLocationByAddressApi({ address: address }).then(res1 => {
            let locationMap = res1.data
            locationMap.dataArr = this.storeList
            this.qqMap(locationMap)
            this.loading = false
          })
        } else {
          this.$message({
            message: '未查询到签到数据',
            type: 'warning'
          })
          this.markerCluster.clearMarkers()
        }
      })
    },
    // 腾讯地图
    qqMap(data) {
      let center = new qq.maps.LatLng(data.lat, data.lng)
      if (this.map === null) {
        this.map = new qq.maps.Map(this.$refs.container, {
          center: center,
          zoom: 11
        })
      } else {
        this.map.setCenter(center)
      }
      if (this.markers === null) {
        this.markers = new qq.maps.MVCArray()
      } else {
        this.markers = []
      }
      for (let i = 0; i < data.dataArr.length; i++) {
        let markerData = data.dataArr[i]
        if (markerData.lat === null || markerData.lat === undefined) continue
        let markerLatLng = new qq.maps.LatLng(markerData.lat, markerData.lng)
        let marker = new qq.maps.Marker({
          //设置Marker的位置坐标
          position: markerLatLng,
          //设置显示Marker的地图
          map: this.map
        })
        if (markerData.realStoreName !== null && markerData.realStoreName !== undefined && markerData.realStoreName.length > 0) {
          marker.setTitle(markerData.storeName + "(" + markerData.realStoreName + ")")
        } else {
          marker.setTitle(markerData.storeName)
        }
        this.markers.push(marker)
      }
      if (this.markerCluster === null) {
        this.markerCluster = new qq.maps.MarkerCluster({
          map: this.map,
          minimumClusterSize: 5, //默认2
          markers: this.markers,
          zoomOnClick: true, //默认为true
          gridSize: 30, //默认60
          averageCenter: true, //默认false
          maxZoom: 18, //默认18
        })
      } else {
        this.markerCluster.clearMarkers()
        this.markerCluster.addMarkers(this.markers)
      }
    },
    // 获取物料使用人下拉框数据
    initUserSelectData() {
      loadUserSelectDataByUserTypeApi().then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.userOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 关闭弹框
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    }
  }
}
</script>
<style lang="scss"  scoped>
::v-deep .el-dialog__body {
  padding: 0 !important;
  top: 40px !important;
  bottom: 0px !important;
}
</style>
